<div class="matero-container-wrap matero-header-above matero-navbar-side" [ngClass]="{
    'matero-sidenav-collapsed': options.sidenavCollapsed,
    'matero-header-white': sharedService.theme === 'light'
  }" [dir]="options.dir">
  <ng-progress name="progress" aria-label="progress"></ng-progress>

  <!-- Header Above -->

  <app-navbar (toggleSidenav)="sidenav.toggle()"></app-navbar>

  <div *ngIf="!production" [ngClass]="{
      'watermark': !isMobile,
      'small-watermark': isMobile
    }">
    <span>{{ build }}</span>
  </div>

  <app-timeout *ngIf="useTimeout"></app-timeout>

  <mat-sidenav-container class="matero-container" autosize autoFocus>
    <mat-sidenav #sidenav class="matero-sidenav" [mode]="isMobile ? 'over' : 'side'" [opened]="sidenavOpen()"
      (openedChange)="sidenavOpenedChange($event)" (closedStart)="sidenavCloseStart()" style="
        background-size: 90%;
        background-repeat: no-repeat;
        background-position: center bottom;
        background-image: url(../../assets/images/OHA-Color-min.png);
      ">
      <app-sidebar (toggleCollapsed)="toggleCollapsed()" (toggleSidenav)="sidenav.toggle()" [isMobile]="isMobile"
        [ripple]="!isMobile">
      </app-sidebar>
    </mat-sidenav>

    <!-- <mat-sidenav-content #content class="flex flex-col matero-content-wrap"> -->
    <mat-sidenav-content #content class="flex matero-content-wrap">
    <!-- <mat-sidenav-content #content style ="display: block; min-height: max-content; " > -->
      <div class="matero-content mb-10">
        <router-outlet *ngIf="!isIframe"></router-outlet>
      </div>
      <app-footer *ngIf="!isMobile" class="w-full fixed bottom-0"></app-footer>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>